(function (w, $) {

    const assetId = '~/Controls/User/Login.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    for (let ctx of w.umwAssets[assetId]) {
        const cont = $('#' + ctx.pnlMainId);
        const $ShowForgotBtn = $('.ShowForgot', cont);
        const $BackBtn = $('.ShowFields', cont);
        const $PnlSignIn = $('#pnlSignIn', cont);
        const $PnlSignedIn = $('#pnlSignedIn', cont);
        const $PanelForgot = $('#pnlForgot', cont);
        const $PanelFields = $('#pnlFields', cont);
        const $PanelAccounts = $('#pnlAccounts', cont);
        const $PanelControls = $('#pnlControls', cont);
        const $PanelVerifyEmail = $('#pnlVerifyEmail', cont);
        const $LnkReLogin = $('.js-uc139-signed-in-relogin', cont);

        $LnkReLogin.click(function(e) {
            e.preventDefault();
            $PnlSignIn.show();
            $PnlSignedIn.hide();
        });

        $ShowForgotBtn.click(function(e) {
            e.preventDefault();

            $.fn.add.call($PanelFields, $PanelControls, $PanelAccounts).hide();
            $PanelForgot.show();

            $PanelForgot
                .find('.FormBox')
                .val($('input[type=text]', $PanelFields).val())
                .select();
        });

        $BackBtn.click(function(e) {
            e.preventDefault();

            $PanelForgot.hide();
            $.fn.add.call($PanelFields, $PanelControls).show();
        });

        // Set focus
        if ($PanelAccounts.is(':visible')) {
            $('select', $PanelAccounts).focus();
        } else {
            $('input[type=text]', $PanelFields).focus();
        }


        /* Email confirmation part setup */
        const $ChangeEmailCont = $('.VrfChangeEmail', $PanelVerifyEmail);
        const $CurrentEmailSpan = $('.currentemail', $PanelVerifyEmail);

        const $ChangeEmailForm = $('.showhide', $ChangeEmailCont);
        const $ChangeEmailInput = $('input:text', $ChangeEmailCont);
        const $ChangeEmailBtn = $('input.OK', $ChangeEmailCont);
        const $CancelChangeBtn = $('input.Cancel', $ChangeEmailCont);

        $ChangeEmailInput
            .keypress(function(e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    $ChangeEmailBtn.click();
                }
            })
            .val($CurrentEmailSpan.text());

        $ChangeEmailBtn.click(function(e) {
            if ($ChangeEmailInput.is(':visible')) {
                if ($CurrentEmailSpan.text() !== $ChangeEmailInput.val())
                    return; // let it post back

                e.preventDefault();
                return;
            }

            e.preventDefault(); // don't postback, show input
            $ChangeEmailForm.show();
        });

        $CancelChangeBtn.click(function(e) {
            e.preventDefault();
            $ChangeEmailForm.hide();
        });
    }
})(window, jQuery);